import { graphql } from '@/client/services/api/graphql/gql';

export const deleteAnnouncementMutation = graphql(`
  mutation DeleteAppAnnouncement($id: String!) {
    deleteAppAnnouncement(id: $id)
  }
`);
